import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantVouchers = (id) => useQuery({ queryKey: [`${id}-vouchers`], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/consultants/${id}/vouchers`)
    return callback?.data
}})

export default useConsultantVouchers